import { Component, TemplateRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface AgGridTemplateRendererComponentParams {
  templateRef: TemplateRef<unknown>;
  templateParams: Record<string, unknown>;
}

@Component({
  selector: 'ag-grid-template-renderer',
  template: `<ng-container [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="templateContext"></ng-container>`,
  styles: `:host { display: flex; height: 100%; align-items: center; flex-grow: 1; min-width: 0 }`,
  standalone: false,
})
export class AgGridTemplateRendererComponent implements ICellRendererAngularComp {
  templateRef: TemplateRef<unknown>;
  templateContext: unknown;

  agInit(params: ICellRendererParams & AgGridTemplateRendererComponentParams): void {
    this.templateRef = params.templateRef;
    this.templateContext = {
      node: params.node,
      row: params.node.data,
      value: params.value,
      api: params.api,
      ...(params.templateParams || {}),
    };
  }

  refresh(): boolean {
    return false;
  }
}
